import type { ModuleId } from '@mentimeter/http-clients';

const SLIDES_WITH_SHOW_MEDIA_ENABLED: ModuleId[] = [
  '100-points',
  'choices',
  'qfa',
  'ranking',
  'rating',
  'scales',
  'wordcloud',
] as const;

export const getCanShowMediaByModuleId = (moduleId: ModuleId) => {
  return SLIDES_WITH_SHOW_MEDIA_ENABLED.includes(moduleId);
};
